import { theme } from '../../style/theme';

export const frostedBackgroundBlurStyle = `
    backdrop-filter: blur(0.71rem);
    -webkit-backdrop-filter: blur(0.71rem);
    background: ${theme.header.opaqueBackgroundColor} !important;
`;


